import service from '@/utils/server';

const modName='/md/deviceGroupAttribute/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

export const exportData = data => {
  return service({
    url: modName + 'export',
    method: 'post',
    data
  });
};





// WEBPACK FOOTER //
// ./src/page/md/deviceGroupAttribute/api/index.js